// removed by extract-text-webpack-plugin
module.exports = {"block--theme-dark":"src-ui-block----index-module---block--theme-dark---3oys-","block--theme-darker":"src-ui-block----index-module---block--theme-darker---2tzQ9"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/block/index.module.scss
// module id = 319
// module chunks = 168707334958949